/*
 * Copyright 2016 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the
 * License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Common methods for both the main app page and standalone widget.
 */

/**
 * @return {string} The reCAPTCHA rendering mode from the configuration.
 */

class firebaseCommon {
  constructor() {}

  getRecaptchaMode() {
    var config = this.parseQueryString(location.hash);
    return config['recaptcha'] === 'invisible' ?
        'invisible' : 'normal';
  }


  /**
   * @return {string} The email signInMethod from the configuration.
   */
  getEmailSignInMethod() {
    var config = this.parseQueryString(location.hash);
    return config['emailSignInMethod'] === 'password' ?
        'password' : 'emailLink';
  }


  /**
   * @return {boolean} The disable sign up status from the configuration.
   */
  getDisableSignUpStatus() {
    var config = this.parseQueryString(location.hash);
    return config['disableEmailSignUpStatus'] === 'true';
  }


  /**
   * @return {boolean} The admin restricted operation status from the configuration.
   */
  getAdminRestrictedOperationStatus() {
    var config = this.parseQueryString(location.hash);
    return config['adminRestrictedOperationStatus'] === 'true';
  }


  /**
   * @param {string} queryString The full query string.
   * @return {!Object<string, string>} The parsed query parameters.
   */
  parseQueryString(queryString) {
    // Remove first character if it is ? or #.
    if (queryString.length &&
        (queryString.charAt(0) == '#' || queryString.charAt(0) == '?')) {
      queryString = queryString.substring(1);
    }
    var config = {};
    var pairs = queryString.split('&');
    for (var i = 0; i < pairs.length; i++) {
      var pair = pairs[i].split('=');
      if (pair.length == 2) {
        config[pair[0]] = pair[1];
      }
    }
    return config;
  }
}

export default {
  firebaseCommon
}